import React, { Component } from "react";
import "./latest-products.scss";
import { Link } from "react-router-dom";

interface MyProps {
  title: string;
  products: any[];
}

interface MyState {
  isMobile: boolean;
}

class LatestProducts extends Component<MyProps, MyState> {
  public Carousel: any;

  responsive = {
    0: { items: 1 },
    500: { items: 2 },
    724: { items: 3 },
    768: { items: 4 },
    1024: { items: 6 },
  };

  constructor(props: MyProps) {
    super(props);
    this.state = {
      isMobile: typeof window !== "undefined" && window.innerWidth <= 768,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    const isMobile = window.innerWidth <= 768;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  };

  render() {
    const { title, products } = this.props;

    const visibleProducts = products.slice(0, 10);

    return (
      <React.Fragment>
        {products && products.length > 0 ? (
          <div className='top-products-container'>
            <div className='title'>{title}</div>
            <div className='top-products-content'>
              <div className='top-products-grid'>
                {visibleProducts.map((product, index) => (
                  <div key={index}>
                    {product}
                  </div>
                ))}
              </div>
              {products.length > 10 && (
                <div className='see-all-button-container'>
                  <Link
                    to='/search'
                    className='see-all-button'
                    onClick={() => window.scrollTo(0, 0)}>
                    Бүгдийг үзэх
                  </Link>
                </div>
              )}
            </div>
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

export default LatestProducts;
